// extracted by mini-css-extract-plugin
export default {"container":"OwnerModal_container__CKuTk"};